import { render } from "./lessons.vue?vue&type=template&id=0691b54c&scoped=true"
import script from "./lessons.vue?vue&type=script&lang=js"
export * from "./lessons.vue?vue&type=script&lang=js"

import "./lessons.vue?vue&type=style&index=0&id=0691b54c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0691b54c"]])

export default __exports__